"use client";

import React, { useEffect, useState } from "react";

// Shown on every page while this browser is in machine-test mode
// (lib/compute_target.js), so a slow or failed render isn't mistaken for the
// live site's.
export default function MachineTestBanner() {
  const [on, setOn] = useState(false);

  useEffect(() => {
    setOn(/(?:^|;\s*)rg_machine=1(?:;|$)/.test(document.cookie) && window.location.pathname !== "/machinetest");
  }, []);

  if (!on) return null;
  const link = { color: "#04121f", fontWeight: 800, textDecoration: "underline" };
  return (
    <div style={{ position: "sticky", top: 0, zIndex: 10000, display: "flex", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: 12,
      padding: "6px 12px", background: "#4fb6ff", color: "#04121f", fontSize: 13, fontWeight: 600, textAlign: "center" }}>
      <span>Machine test — rendering on the home PC.</span>
      <a href="/machinetest" style={link}>Status / turn off</a>
    </div>
  );
}
